
(function () {
  'use strict';

  if (window.__wcEdgeSwipeBack) return;
  window.__wcEdgeSwipeBack = true;

  var EDGE_ZONE_PX    = 200;    
  var MIN_DISTANCE_PX = 45;     
  var FLICK_VELOCITY  = 0.4;    
  var FLICK_MIN_PX    = 25;     
  var MAX_VERTICAL_PX = 60;
  var MAX_DURATION_MS = 1500;
  var COMMIT_MS       = 120;    

  var SNAP_BACK_MS    = 200;

  var startX = 0;
  var startY = 0;
  var startT = 0;
  var tracking = false;
  var mode = 'idle';            
  var bodyEl = null;
  var htmlEl = null;
  var savedHtmlBg = '';
  var drawerEl = null;          
  var drawerCloseFn = null;     

  

  

  function findOpenCartContext() {
    var cd = document.querySelector('cart-drawer.active');
    if (!cd) return null;
    var inner = cd.querySelector('.drawer__inner');
    if (!inner) return null;
    return {
      paintEl: inner,
      closeFn: function () { if (typeof cd.close === 'function') cd.close(); }
    };
  }
  function findOpenMenuContext() {
    var summary = document.querySelector('details[open] > summary[aria-controls^="menu-drawer"]');
    if (!summary) return null;
    var details = summary.parentElement;
    var panel = details ? details.querySelector('.menu-drawer__inner-container, .menu-drawer') : null;
    if (!panel) return null;
    return {
      paintEl: panel,
      closeFn: function () { summary.click(); }
    };
  }

  

  
  
  function isPdpCarouselPastFirstImage() {
    var slider = document.querySelector('slider-component.wc-pdp-main-slider');
    if (!slider) return false;
    if (typeof slider.currentPage === 'number' && slider.currentPage > 1) return true;
    var scroller = slider.slider || slider.querySelector('[id^="Slider-"]');
    if (scroller && scroller.scrollLeft > 10) return true;
    return false;
  }

  

  
  var ourBodyStyles = false;

  
  
  var bodyTransformApplied = false;

  function pageBeginPaint() {
    bodyEl = document.body;
    htmlEl = document.documentElement;
    savedHtmlBg = htmlEl.style.backgroundColor || '';

    

    

    

    
    
    bodyEl.style.transition = 'none';

    
    
    ourBodyStyles = true;
  }
  function pagePaint(dx) {
    if (!bodyEl) return;

    if (dx < 4 && !bodyTransformApplied) return;
    if (!bodyTransformApplied) {
      bodyEl.style.willChange = 'transform';
    }
    bodyEl.style.transform = 'translateX(' + dx + 'px)';
    bodyTransformApplied = true;
  }
  function pageCommitOff() {
    if (!bodyEl) return;
    bodyEl.style.transition = 'transform ' + COMMIT_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    bodyEl.style.transform = 'translateX(100vw)';
    setTimeout(function () {
      if (window.history && window.history.length > 1) {
        window.history.back();
      } else {
        pageSnapBack();
      }
    }, COMMIT_MS);
  }
  function pageSnapBack() {
    if (!bodyEl) return;

    if (!bodyTransformApplied) {
      bodyEl.style.transition = '';
      bodyEl.style.willChange = '';
      ourBodyStyles = false;
      bodyEl = null;
      htmlEl = null;
      return;
    }
    
    bodyEl.style.transition = 'transform ' + SNAP_BACK_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    bodyEl.style.transform = 'translateX(0px)';
    var b = bodyEl, h = htmlEl, bg = savedHtmlBg;
    setTimeout(function () {
      b.style.transform = '';
      b.style.transition = '';
      b.style.willChange = '';
      h.style.backgroundColor = bg;
      ourBodyStyles = false;
      bodyTransformApplied = false;
    }, SNAP_BACK_MS + 10);
    bodyEl = null;
    htmlEl = null;
  }

  function drawerBeginPaint(ctx) {
    drawerEl = ctx.paintEl;
    drawerCloseFn = ctx.closeFn;
    drawerEl.style.transition = 'none';
    drawerEl.style.willChange = 'transform';
    drawerEl.style.transform = 'translateX(0px)';
  }
  function drawerPaint(dx) {
    if (drawerEl) drawerEl.style.transform = 'translateX(' + dx + 'px)';
  }
  function drawerCommitClose() {
    if (!drawerEl) return;
    var el = drawerEl;
    var fn = drawerCloseFn;

    

    
    el.style.transition = '';
    el.style.transform  = '';
    el.style.willChange = '';
    if (typeof fn === 'function') fn();
    drawerEl = null;
    drawerCloseFn = null;
  }
  function drawerSnapBack() {
    if (!drawerEl) return;
    var el = drawerEl;
    el.style.transition = 'transform ' + SNAP_BACK_MS + 'ms cubic-bezier(.2,.8,.4,1)';
    el.style.transform = 'translateX(0px)';
    setTimeout(function () {
      el.style.transform = '';
      el.style.transition = '';
      el.style.willChange = '';
    }, SNAP_BACK_MS + 10);
    drawerEl = null;
    drawerCloseFn = null;
  }

  function onStart(e) {
    if (!e.touches || e.touches.length !== 1) return;
    var t = e.touches[0];
    if (t.clientX > EDGE_ZONE_PX) return;

    

    
    
    if (document.body.classList.contains('wc-modal-open')) return;

    
    if (isPdpCarouselPastFirstImage()) return;

    var ctx = findOpenCartContext() || findOpenMenuContext();
    if (ctx) {
      mode = 'drawer';
      drawerBeginPaint(ctx);
    } else {
      mode = 'page';
      pageBeginPaint();
    }
    startX = t.clientX;
    startY = t.clientY;
    startT = Date.now();
    tracking = true;
  }

  function onMove(e) {
    if (!tracking) return;
    if (!e.touches || !e.touches[0]) return;
    var t = e.touches[0];
    var dx = Math.max(0, t.clientX - startX);
    var dy = Math.abs(t.clientY - startY);
    if (dy > MAX_VERTICAL_PX) {
      tracking = false;
      if (mode === 'page') pageSnapBack(); else drawerSnapBack();
      mode = 'idle';
      return;
    }
    if (mode === 'page') pagePaint(dx); else drawerPaint(dx);
  }

  function onEnd(e) {
    if (!tracking) return;
    tracking = false;
    var t = e.changedTouches && e.changedTouches[0];
    var dx = t ? (t.clientX - startX) : 0;
    var dy = t ? Math.abs(t.clientY - startY) : 999;
    var dt = Date.now() - startT;

    var velocity = dt > 0 ? dx / dt : 0;
    var passed =
      dx >= MIN_DISTANCE_PX ||
      (velocity >= FLICK_VELOCITY && dx >= FLICK_MIN_PX);
    var success =
      passed &&
      dy <= MAX_VERTICAL_PX &&
      dt <= MAX_DURATION_MS;

    if (mode === 'page') {
      if (success) pageCommitOff(); else pageSnapBack();
    } else if (mode === 'drawer') {
      if (success) drawerCommitClose(); else drawerSnapBack();
    }
    mode = 'idle';
  }

  function onCancel() {
    if (!tracking) return;
    tracking = false;
    if (mode === 'page') pageSnapBack();
    else if (mode === 'drawer') drawerSnapBack();
    mode = 'idle';
  }

  document.addEventListener('touchstart',  onStart,  { passive: true });
  document.addEventListener('touchmove',   onMove,   { passive: true });
  document.addEventListener('touchend',    onEnd,    { passive: true });
  document.addEventListener('touchcancel', onCancel, { passive: true });

  

  window.addEventListener('pageshow', function () {
    if (!ourBodyStyles) return;
    var b = document.body;
    var h = document.documentElement;
    if (b) { b.style.transform = ''; b.style.transition = ''; b.style.willChange = ''; }
    if (h) { h.style.backgroundColor = ''; }
    ourBodyStyles = false;
  });
})();